import React from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'

import './BatteryMap.css'
import { BackButton } from '@/components/layout/NavBar'
import BatteryMapComponent from '@/components/Map/BatteryMap'

export const BatteryMapPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  // const { translates } = session

  return <LoggedInPageLayout pageName='dashboard-battery-map' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    {/* <div className='dashboard-map'> */}
    <BatteryMapComponent fetchUrl='/api/communal/map' services={services} session={session} />
    {/* </div> */}
  </LoggedInPageLayout>
}
